(function (fox, $) {
	"use strict";

	fox.registerWidget('BillingSupport_CancellationForm', {

		configure: function () {
			this.data = {};

			this.registerOptions('', {
				container: '.cancellation-form-wrapper',
				template: 'billingSupport_cancellation_form',
				autoRender: true,
				widgets: {
					reasonsApi: {
						widget: 'Api',
						method: 'User_Cancelation.cancelReasonsList'
					},
					cancelApi: {
						widget: 'Api',
						method: 'User.cancel'
					},
					reasonsList: {
						widget: 'Widget',
						autoRender: false,
						container: '.select',
						template: 'billingSupport_cancellation_form_select'
					},
					billingContactApi: {
						widget: 'Api',
						method: 'User.supportContact'
					},
					discountPopup: {
						widget: 'Cancellation_Offer_Popup',
						onCancelPress: (...args) => this.submit(...args),
					},
					confirmationPopup: {
						widget: 'GDPR_BasePopup',
						onOkPress: (...args) => this.submit(...args),
						contentTemplate: 'popup_billingInfo_cancellation_confirm'
					},
					successPopup: {
						widget: 'GDPR_BasePopup',
						onOkPress: (...args) => this.hide(),
						contentTemplate: 'popup_billingInfo_cancellation_success'
					},
					errorPopup: {
						widget: 'GDPR_BasePopup',
						onOkPress: (...args) => this.hide(),
						contentTemplate: 'popup_billingInfo_cancellation_error'
					}
				},

				handleDom: {
					select: {
						targetWidget: '#reasonsList',
						target: 'select[name="reason"]',
						event: 'change',
						callback: '_change'
					},

					input: {
						target: '[name="message"]',
						event: 'input',
						callback: '_handleInput'
					},

					focus: {
						target: '[name="message"]',
						event: 'focus',
						callback: function () {
							this.dom1('[name="message"]').placeholder = '';
						}
					},

					send: {
						target: '.send-message',
						event: 'click',
						callback: '_send'
					},

					confirm: {
						targetWidget: '#confirmationPopup #content',
						target: '.submit',
						event: 'click',
						callback: 'submit'
					}
				},

				handleWom: {
					handleReasonsApiResponse: {
						widget: '#reasonsApi',
						event: ['success', 'failure'],
						callback: '_handleReasonsApiResponse'
					},
					handleCancelApiResponse: {
						widget: '#cancelApi',
						event: ['success', 'failure', 'error'],
						callback: '_handleCancelApiResponse'
					},

					handleSupportApiResponse: {
						widget: '#billingContactApi',
						event: ['success', 'failure', 'error'],
						callback: '_handleBillingContactApiResponse'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function (argument) {
			this.getReasons();
			this.callParent('running', arguments);
		},

		deactivate: function (argument) {
			this.resetData();
			this.callParent('deactivate', arguments);
		},

		getReasons: function (argument) {
			this.wom1('#reasonsApi').send();
		},

		_handleReasonsApiResponse: function (response, api, e) {
			if (e === 'failure') {
				console.error(e);

				return;
			}

			var list = [{title: 'Select', value: 0}];

			fox.each(response.answer.response, function (obj, alias) {
				obj.value = obj.id;
				obj.title = obj.title.ucfirst();

				list.push(obj);
			});

			this.renderReasonsList(list);
		},

		_handleCancelApiResponse: function (response, api, e) {
			if (response.answer.status === false) {
				console.warn('cancellation api failure, try to send billing contact form');
				this.sendMessageToBillingSupport();

				return;
			}

			fox.UserOffer.checkAction('userCanceled');

			fox.setEnv('user.canceled', 1);
			fox.setEnv('user.expDate', fox.utils.dateFormat('%Y-%m-%d', response.answer.response.expDate));
			console.log(response.answer.response);
			const resp = response.answer.response;
			if (resp.isUserAlreadyCanceled === true){
			this.wom1('#successPopup #content').setTemplateOptions({isUserAlreadyCanceled: 1, expireDate: resp.expDate});
			this.wom1('#successPopup #content').render();
			}
			if (!fox.UserOffer.checkAction('afterCancel', {'callback': fox.bind(this.showSuccessPopup, this)})) {
				this.showSuccessPopup();
			}
		},

		renderReasonsList: function (list) {
			this.wom1('#reasonsList').setTemplateOptions('list', list);
			this.wom1('#reasonsList').render();
		},

		_change: function (el) {
			var option = el.options[el.selectedIndex];

			this.insertSelectTitle(option.innerHTML);
			this.toggleField('reason', false);

			this.data.reason = option.value;
		},

		insertSelectTitle: function (txt) {
			this.dom1('.selected').innerHTML = txt;
		},

		resetData: function () {
			this.data = {};
		},

		_send: function () {
			var cancellation = fox.site.wom1('~.BillingSupport_Cancellation');
			this.discount = cancellation.cancellationDiscount;
			this.data.message = this.dom1('[name="message"]').value;

			if (this.data.message === '') {
				this.dom1('[name="message"]').placeholder = 'Cannot be empty';
			}

			if (this.isValid()) {
				if (this.discount) {
					
					this.showDiscountPopup();
				} else {
					this.showConfirmationPopup();
				}
			}
		},

		submit: function  (btn) {
			$(btn).prop('disabled', true);
			$(btn).addClass('spin');
			return this.wom1('#cancelApi').psend(this.data).then(function (resp) {
				return true;
			}.bind(this)).catch(function (e) {
				return e;
			}.bind(this));
		},

		showDiscountPopup: function () {
			var discountPopup = this.wom1('#discountPopup');
			discountPopup.wom1('#content')
				.setTemplateOptions({
					'discounts': this.discount
				})
				.render();
			discountPopup.show();
		},

		onCancel: function() {

		},

		isValid: function () {
			if (!fox.isEmpty(this.data.reason) && !fox.isEmpty(this.data.message)) {
				return true;
			}

			fox.each(['reason', 'message'], function (alias) {
				this.toggleField(alias, false);
				if (fox.isEmpty(this.data[alias])) {
					this.toggleField(alias, true);
				}
			}, this);
			return false;
		},

		toggleField: function (alias, state) {
			var action = (state === true ? 'addClass' : 'removeClass');
			var field = this.dom1('[name="' + alias + '"]');
			var parent = field.parentNode;

			if (alias === 'reason') {
				field = this.wom1('#reasonsList').dom1('[name="' + alias + '"]');
				parent = field.parentNode.parentNode;
			}

			fox.dom[action]('error', parent);
		},

		_handleInput: function (el) {
			if (el.value.length > 0) {
				this.toggleField(el.name, false);
			}
		},

		showConfirmationPopup: function (argument) {
			this.wom1('#confirmationPopup').show();
		},

		showSuccessPopup: function (argument) {
			this.wom1('#successPopup').show();

			this.handleEvent(this.wom1('#successPopup'), 'hide', this._redirect, { once: true });
		},

		showErrorPopup: function (argument) {
			this.wom1('#errorPopup').show();
		},

		_redirect: function (argument) {
			fox.site.gotoPage('account');
			window.location.reload();
		},

		sendMessageToBillingSupport: function (argument) {
			var api = this.wom1('#billingContactApi');

			this.wom1('#billingContactApi').send({
				firstname: 'ModelCentro',
				lastname: 'Forward',
				description: 'user tried to cancel membership from model\'s site, but cancellation attempt resulted in an error. Please cancel membership and notify user asap.',
				problem: 'Subscription Cancellation'
			});
		},

		_handleBillingContactApiResponse: function (response, api, e) {
			if (e === 'failure' || e === 'error') {
				this.showErrorPopup();
				console.warn(arguments);
				return;
			}

			this.showSuccessPopup();
		}

	}, 'Widget');

})(fox, fox.jQuery);


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/billingSupport/cancellationForm.es.js